import { useId } from 'react';

export default function RedashDashboard({
  title,
  dashboardUrl,
  className,
  height,
  width,
}) {
  const id = useId();

  return (
    <div className={className}>
      <h2>{title}</h2>
      <iframe
        id={id}
        title={title}
        src={dashboardUrl}
        width={width}
        height={height}
      />
    </div>
  );
}
